import { app } from '../../../app';
import {Controller} from "./recovery.controller";

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('company.recovery', {
        url: '/recovery',
        templateUrl: require('./recovery.html'),
        controller: Controller
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/recovery-center/recovery.state.js